import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { FaFilter } from "react-icons/fa";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import { CSVLink } from "react-csv";

import ApiUiController from "../../controller/ApiUiController";
import FieldController from "../../controller/FieldController";
import ReportAPI from "../../api/ReportAPI";
import FilterDate from "../filter/FilterDate";
import FilterPannel from "../filter/FilterPannel";
import Const from "../../util/Constants";
import withRouter from "../../util/WithRouter";
import Util from "../../util/Util";
import ReportWidget from "./ReportWidget";
import ViewController from "../../controller/ViewController";

class ReportSelect extends React.Component {
  constructor(props) {
    super(props);
    this.models = reactLocalStorage.getObject(Const.Model);
    this.export = [];

    const user = reactLocalStorage.getObject(Const.LoggedInUser);
    this.children = [user.user_id, ...user.child];

    this.report = props.report;
    this.rows = [];
    this.data = null;
    const model = this.models[this.report.model.split(" ")[0]];
    this.model = model;
    this.Restrict = Util.isAllow(this.model.permission, Const.PermRestricAcc);
    const filters = [];
    if (this.report.filter) {
      const filter = JSON.parse(this.report.filter);
      for (let i = 0; i < filter.length; i++) {
        filters.push({ ...filter[i] });
        filters[i].value = FilterDate.getValue(filters[i].value ? filters[i].value : filters[i].condition);
      }
    }
    this.filters = ViewController.filters(filters, [], this.Restrict);
    this.state = { isFilterOpen: true, inApiCall: false };
  }

  componentDidMount() {
    this.loadReports();
  }

  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onData = (res) => {
    new Promise(resolve => {
      resolve(this.calculte(res));
    }).then(data => {
      this.res = res;
      this.data = data;
      this.setState({ ...this.state, inApiCall: false });
    });
  };

  onFilterChange = (filters) => {
    this.filters = filters;
    this.setState({ ...this.state, inApiCall: true });
    this.loadReports();
  };

  loadReports = () => {
    const restrict = this.filters.find(
      (filter) => filter.field === "responsible_person"
    );
    if (this.Restrict && !restrict) {
      this.filters.push({
        field: "responsible_person",
        type: "multiselect~user",
        condition: "in",
        value: `${Const.Opt}${this.children.join(Const.Opt)}${Const.Opt}`,
      });
    }

    if (this.props.saveFilter) {
      this.props.saveFilter(this.filters);
    }
    ReportAPI.data(this.report.id, this.filters, this.onData, this.onFail);
  };

  calculte = (res) => {
    const model = this.models[this.report.model];
    if (!model) return { headers: [], body: [] };

    const y = this.report.y;

    const user = reactLocalStorage.getObject(Const.LoggedInUser);
    const children = [user.user_id, ...user.child];

    let yOptions = FieldController.getOptions(model.fields[y], undefined, true);
    if (this.restrict && model.fields[y].field_type.includes("~user")) {
      yOptions = yOptions.filter(
        (opt) =>
          children.find((child) => parseInt(child) === parseInt(opt.value)) !==
          undefined
      );
    }
    let filter = this.filters.find(
      (filter) => filter.field === model.fields[y].field_key
    );
    if (filter)
      yOptions = yOptions.filter((opt) =>
        filter.value.includes(`${Const.Opt}${opt.value}${Const.Opt}`)
      );
    this.yOptions = yOptions;

    const rows = yOptions.map((option) => option.label);
    const body = [];
    let total = 0;
    for (let i = 0; i < rows.length; i++) {
      const yVal = yOptions[i].value;
      let yType = model.fields[y].field_type;
      yType = yType.includes(Const.MultiSelect);

      const tmp = yType ? res.filter((itm) => itm[y] && itm[y].includes(`~${yVal}~`)) : res.filter((item) => item[y] === yVal);
      let count = 0;
      for (let k = 0; k < tmp.length; k++) {
        count += tmp[k].sum;
      }
      total += count;
      body.push([rows[i], count]);
    }
    body.push(["Total", total]);

    this.export = [[this.model.fields[this.report.y].label_name], ...body];
    return body;
  };

  loadView = (i, j) => {
    if (j === 0) return;
    const filters = [...this.filters];
    const type = this.models[this.report.model].fields[this.report.y].field_type;
    if (type === Const.Complete) {
      if (i < this.yOptions.length) {
        filters.push({ field: this.report.y, type, condition: this.yOptions[i].value === Const.True ? 'not-in' : 'in' });
      }
    } else {
      let value;
      if (i < this.yOptions.length) {
        value = `${Const.Opt}${this.yOptions[i].value}${Const.Opt}`;
      } else {
        value = `${Const.Opt}${this.yOptions.map((opt) => opt.value).join(Const.Opt)}${Const.Opt}`;
      }
      filters.push({ field: this.report.y, type, condition: "in", value });
    }

    const model = this.report.model !== "sales_order" ? this.report.model : "sales-order";
    this.props.navigate(`/${model}?filters=${JSON.stringify(filters)}`);
  };

  toggleFilter = () =>
    this.setState({ ...this.state, isFilterOpen: !this.state.isFilterOpen });

  render() {
    const body = this.data
      ? this.data.map((row, i) => (
        <tr key={`body_${i}`}>
          {row.map((item, j) => (
            <td key={`body_${i}_${j}`} onClick={() => this.loadView(i, j)}>
              {item}
            </td>
          ))}
        </tr>
      ))
      : null;
    const field = (this.report.y).includes(".") ? (this.report.y).split(".")[1] : this.report.y;
    let table = (
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>{this.model.fields[field].label_name}</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody className="listlead">{body}</tbody>
      </Table>
    );

    if (this.props.dashbaord) {
      return (
        <div className="col-md-3">
          <div className="dashboard-report-titles mt-3">{this.report.name}</div>
          <div>
            <ApiUiController inApiCall={this.state.inApiCall}>
              {table}
            </ApiUiController>
          </div>
        </div>
      );
    }

    return (
      <ApiUiController inApiCall={this.state.inApiCall}>
        <div className="container-fluid ">
          <div className="row">
            <div className="col-md-8">
              <div className="row">
                <div className="col-md-6">{this.report.name}</div>
                <div className="col-md-6">
                  <CSVLink data={this.export}>
                    <Button className="buttons btn-success">Export</Button>
                  </CSVLink>
                </div>
              </div>
            </div>
            <div className="col-md-4 pt-1">
              <div className="row filterrow">
                <div className="col-md-12 lastcol">
                  <div className="m-right">
                    <div
                      className="btn btn-lead btn-sm filter-button"
                      onClick={this.toggleFilter}
                    >
                      <FaFilter />
                      <span className="badge badge-danger badge-mini rounded-circle">
                        {this.filters.length}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row pt-3">
            <div className="container-fluid ">
              <div className="row">
                <div className={`col-md-${this.state.isFilterOpen ? 9 : 12}`}>
                  {this.res ? (
                    <ReportWidget
                      view_type={this.report.view_type}
                      type={this.report.type}
                      model={this.report.model}
                      x={this.report.x}
                      y={this.report.y}
                      z={this.report.z}
                      filters={this.filters}
                      data={this.res}
                      name={this.report.name}
                    />
                  ) : null}
                  <div className="col-md-12"> {table} </div>
                </div>
                <FilterPannel
                  filters={this.filters}
                  fields={this.model.fields}
                  onFilterChange={this.onFilterChange}
                  isFilterOpen={this.state.isFilterOpen}
                  restrict={this.Restrict}
                />
              </div>
            </div>
          </div>
        </div>
      </ApiUiController>
    );
  }
}
export default withRouter(ReportSelect);